import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {

  @Input() nome: string;
  @ViewChild("card", null)

  private card: ElementRef;
  public formModalInfo = null;
  public isSaldoCorrente = false;
  public isValorRecebiveis = false;
  public isSaldoOnerado = false;

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalInfoComponent>
  ) { }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();

    if (this.nome === 'contaCorrente') {
      this.isSaldoCorrente = true;
    } else if (this.nome === 'valorRecebiveis') {
      this.isValorRecebiveis = true;
    } else if (this.nome === 'saldoOnerado'){
      this.isSaldoOnerado = true;
    }

  }

  voltar() {
    this.ref.close();
  }

}
